<template>
  <div class="flex w-full justify-center">
    <div class="mx-2 w-full md:mx-10 md:px-0 xl:w-5/6">
      <slot />
    </div>
  </div>
</template>
